export default __webpack_public_path__ + "static/columnSpanning-a91d0e524762476ab51950fb30120458.gif";